/**
 * Ollie is only available on venue dashboard routes (/v/:venueId/...).
 * Not on supplier portal, OMS admin, or the /venues picker.
 */
function isVenueDashboardRoute(pathname = '') {
  return /^\/v\/[^/]+(?:\/|$)/.test(pathname)
}

function getVenueIdFromPath(pathname = '') {
  if (!isVenueDashboardRoute(pathname)) {
    return null
  }

  const segments = pathname.split('/').filter(Boolean)
  return segments[1] || null
}

module.exports = {
  isVenueDashboardRoute,
  getVenueIdFromPath,
}
